/**
 * One-shot full-viewport confetti after a quote is accepted.
 * Canvas uses pointer-events: none so page / dialog CTAs stay clickable.
 * zIndex is above Rocco modal (140) so particles stay visible over the
 * post-accept payment-method popup.
 */
export async function fireQuoteAcceptedConfetti(): Promise<void> {
    if (typeof window === 'undefined') {
        return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    const { default: confetti } = await import('canvas-confetti');

    const defaults = {
        zIndex: 200,
        disableForReducedMotion: true,
    } as const;

    confetti({
        ...defaults,
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
    });

    // Side bursts so confetti frames the payment dialog, not only behind it.
    confetti({
        ...defaults,
        particleCount: 40,
        angle: 60,
        spread: 55,
        origin: { x: 0, y: 0.65 },
    });
    confetti({
        ...defaults,
        particleCount: 40,
        angle: 120,
        spread: 55,
        origin: { x: 1, y: 0.65 },
    });
}
